<template>
    <el-container class="home" style="height: 100vh" v-loading="loading">
        <el-header class="topPanel" style="line-height: 50px;height: 50px;background-color: #1c88c9">
            <navTop @changePassword="changePassword"
                    @clickMsg="clickMsg"
                    @clickTask="clickTask"
                    >
            </navTop>
        </el-header>
        <el-container class="bodyPanel">
            <el-aside width="235px"
                      style="padding:10px 0 0 10px;border-bottom: 2px solid #c8c9cc;border-right: 2px solid #c8c9cc;">
                <aside-menu @hand-change="handChange" :isCollapse="isCollapse"
                            :actIndex="actIndex">
                </aside-menu>
            </el-aside>
            <el-main class="mainPanel">
                <el-container>
                    <el-header style="height: 40px">
                        <div style="display: flex;flex-direction:row;height:40px;line-height:20px;border-bottom: 1px solid #c8c9cc;">
                            <menuTabs :open-tab="openTab" :act-index.sync="actIndex" @tabClick="tabClick"
                                      @tabRemove="tabRemove" @changeTabs="changeTabs">
                            </menuTabs>
                        </div>
                    </el-header>

                    <el-main style="margin-top:5px;height:calc(100vh - 145px)">
                        <el-scrollbar style="height:100%;width: 100%;">
                            <div>
                                <!-- 路由包裹了动画标签 animate.css库动画 -->
                                <transition
                                        mode="out-in"
                                        enter-active-class="animate__animated animate__slideInLeft"
                                        leave-active-class="animate__animated animate__slideOutRight">

                                    <router-view class="routeView" id="dowebok" :key="actIndex" :menuData="menuData"
                                                 @toMenu="toMenu"/>
                                </transition>
                            </div>
                        </el-scrollbar>
                    </el-main>
                </el-container>
            </el-main>
        </el-container>

        <el-footer style="line-height: 30px;height: 30px;background-color: #f2f2f2">
            <span style="float:left;padding-left:5px;width:40%;text-align: left;">{{departmentNameLogin}}/</span>
            <span style="float:left;padding-right:5px;width:35%;text-align: left">{{projectName}}</span>
            <span style="float:left;padding-right:5px;width:15%;text-align: left;">记账月份：{{MonthAccount}}&nbsp;</span>
        </el-footer>


        <editDialog v-if="showEditDialog"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog">
        </editDialog>
    </el-container>
</template>

<script>
    import AsideMenu from "@/components/home/asideMenu";
    import navTop from "@/components/home/navTop";
    import menuTabs from "@/components/home/menuTabs"
    import editDialog from "@/components/system/usermanage/editPassword"

    export default {
        name: "home",
        components: {
            AsideMenu,
            navTop,
            menuTabs,
            editDialog,
        },
        data() {
            return {
                loading: false,
                projectName: window.host.projectName,
                openTab: [{
                    menuId: "0",
                    menuUrl: "/main",
                    menuName: "首页",
                }],
                actIndex: "/main",
                breadcrumbList: [],
                isCollapse: false,
                menuData: {},
                transitionName: "slide-left",
                showEditDialog:false,

                loginInfo: this.$store.state.loginInfo,
                MonthAccount: this.$store.state.loginInfo.MonthAccount,
                userName: this.$store.state.loginInfo.user.userName,
                departmentNameLogin: this.$store.state.loginInfo.user.departmentNameLogin,
                menuList: this.$store.state.loginInfo.menuList,
            };
        },
        watch: {
            '$route'(to, from) {
                const fromDepth = to.meta.depth;
                const toDepth = from.meta.depth;
                this.transitionName =
                    toDepth < fromDepth ? "slide-right" : "slide-left";
            }
        },
        async mounted() {
            this.loading = true;
            await this.getUserInfo();
            // await this.getMenuList();
            this.loading = false;
            // //默认打开首页
            if (this.$route.path != "/home" && this.$route.path != "/main") {
                const selTab = this.getMenu(this.menuList, this.$route.path);
                this.setTab(selTab);
            }
        },
        methods: {
            clickMsg() {
                this.toMenu('/usermessage');
            },
            clickTask() {
                this.toMenu('/task/runTask');
            },
            changePassword() {
                this.showEditDialog = true;
            },
            closeDialog() {
                this.showEditDialog = false;
            },
            async getUserInfo() {
                // let param = {
                //     url:"/main/index",
                // }
                // const data = await this.$store.dispatch('pubMethod', param)
                // this.loginInfo = data.data;
                // this.$store.state.loginInfo = data.data;
                // this.menuList = data.data.menuList;
                //
                // param = {
                //     url:"/head/getInfo",
                // }
                // const ret = await this.$store.dispatch('pubMethod', param)
            },

            toMenu(data) {
                const selTab = this.getMenu(this.menuList, data);
                this.setTab(selTab);
                this.$router.push({path: data});
            },
            //切换tab页面
            async setTab(selTab) {
                if (!selTab.menuUrl)
                    return;
                let obj = this.openTab.find(item => item.menuUrl === selTab.menuUrl)
                if (!obj) {
                    this.openTab.push(selTab);
                }
                this.actIndex = selTab.menuUrl;
                this.breadcrumbList = [selTab.menuName];
                this.menuData = selTab;
            },
            //获取当前点击的页面
            getMenu(menuList, path) {
                let obj = {};
                for (let i in menuList) {
                    let menu = menuList[i];
                    let url = menu.menuUrl;
                    if (url == path) {
                        return menu;
                    }
                    if (menu.subMenu.length > 0) {
                        obj = this.getMenu(menu.subMenu, path);
                    }
                    if (Object.keys(obj).length > 0) {
                        break;
                    }
                }
                return obj;
            },
            changeTabs(command) {
                if (command === "close-current") this.tabRemove(this.actIndex);
                else if (command === "close-other") this.tabRemoveOther(this.actIndex);
                else if (command === "close-all") {
                    this.tabRemoveOther(this.actIndex);
                    this.tabRemove(this.actIndex);
                }
            },
            async handChange(data) {
                let selTab = this.getMenu(this.menuList, data);
                if (data === "/main") {
                    selTab = {
                        code: "0",
                        menuUrl: "/main",
                        name: "首页"
                    }
                }
                await this.setTab(selTab);
            },
            //tab标签点击时，切换相应的路由
            async tabClick(index) {
                await Promise.all(this.openTab.map(async item => {
                    if (item.menuUrl === index) {
                        this.menuData = item;
                    }
                }))
                this.$router.push({path: index});
            },
            tabRemoveOther(targetName) {
                this.openTab = this.openTab.filter(item => {
                    return item.menuUrl == "/home" || item.menuUrl == "/main" || item.menuUrl == targetName
                })
            },
            //移除tab标签
            async tabRemove(targetName) {
                //首页不删
                if (targetName == "/home" || targetName == "/main") {
                    return;
                }
                await Promise.all(this.openTab.map(async (item, index) => {
                    if (item.menuUrl === targetName) {
                        this.openTab.splice(index, 1);
                        this.actIndex = this.openTab[this.openTab.length - 1].menuUrl;
                        this.breadcrumbList = this.openTab[this.openTab.length - 1].breadcrumbs;
                        // this.menuData = item;
                    }
                }))
                this.$router.push({path: this.actIndex});
            },
        },
    };
</script>
<style lang="scss" scoped>
    .mainPanel .el-header {
        padding: 0px;
    }

    .home {
        .el-footer {
            background-color: #B3C0D1;
            color: #333;
            text-align: center;
        }

        .bodyPanel {
            .el-aside {
                background-color: #f2f2f2;
                color: #333;
                text-align: center;
            }

            .mainPanel {
                padding: 10px;
                background-color: #FFFFFF;
                color: #333;
                text-align: center;
                /*line-height: 160px;*/
                .el-main {
                    padding: 0px;
                }
            }
        }
    }
</style>
